webpackJsonp([35783957827783],{

/***/ 42:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 240:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsListing = function NewsListing(props) {
	    return _react2.default.createElement(
	        'section',
	        { className: 'features', id: 'features' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card mb-4 box-shadow' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'card-text' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Easy to Use'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Web UI: Now configure and monitor OWTF via a responsive and powerful interface accessible via your browser. '
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Exposes RESTful APIs to all core OWTF capabilties.'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card mb-4 box-shadow' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'card-text' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Unites popular tools'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Instead of implementing yet another spider (a hard job), ',
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'OWTF'
	                                    ),
	                                    ' will scrub the output of all tools/plugins run to gather as many URLs as possible.'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Scan by various aggression levels: ',
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'OWTF'
	                                    ),
	                                    ' supports scans which are based on the ',
	                                    _react2.default.createElement(
	                                        'i',
	                                        null,
	                                        'aggressiveness'
	                                    ),
	                                    ' of the plugins/tools invoked.'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'strong',
	                                        null,
	                                        'Extensible'
	                                    ),
	                                    ' ',
	                                    _react2.default.createElement(
	                                        'b',
	                                        null,
	                                        'OWTF'
	                                    ),
	                                    ' manages tools through ',
	                                    _react2.default.createElement(
	                                        'i',
	                                        null,
	                                        '\'plugins\''
	                                    ),
	                                    ' making it trivial to add new tools. '
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card mb-4 box-shadow' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'card-text' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Use OWTF anywhere!'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'OWTF provides a Dockerfile to run on any platform Docker supports!'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'A new Docker Compose version coming soon...'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'unique' },
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                ' Fastest Python MiTM proxy yet!'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Comprehensive interactive report at end of each scan'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-sm' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'Easy plugin-based system; currently 100+ plugins!'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                'CLI and web interface'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'ten columns offset-by-one' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Video: Release preview'
	                        ),
	                        _react2.default.createElement('iframe', { src: 'https://player.vimeo.com/video/128008174', width: '500', height: '313' })
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button', className: 'btn btn-primary btn-lg' },
	                        _react2.default.createElement(
	                            'a',
	                            { href: '//imgur.com/a/ISOb9' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Screenshots'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        'Tested on ',
	                        _react2.default.createElement('img', { src: 'https://www.browserstack.com/images/layout/browserstack-logo-600x315.png', height: '100', width: '200', alt: 'Browserstack' })
	                    )
	                )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	                'section',
	                { className: 'download', id: 'download' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Getting started with ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'OWTF'
	                    ),
	                    '!'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { id: 'cmd' },
	                    _react2.default.createElement(
	                        'code',
	                        null,
	                        'pip install git+https://github.com/owtf/owtf#egg=owtf or clone the repo and python setup.py install'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'To run OWTF on Windows or MacOS, use the Dockerfile (requires ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Docker'
	                    ),
	                    ' installed) provided to try OWTF:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { id: 'cmd-lg' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'code',
	                            null,
	                            'make docker-build && make docker-run'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Open ',
	                        _react2.default.createElement(
	                            'code',
	                            null,
	                            '~/.owtf/conf'
	                        ),
	                        ' and change ',
	                        _react2.default.createElement(
	                            'code',
	                            null,
	                            'SERVER_ADDR: 127.0.0.1'
	                        ),
	                        ' to ',
	                        _react2.default.createElement(
	                            'code',
	                            null,
	                            'SERVER_ADDR: 0.0.0.0'
	                        ),
	                        '.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Create a virtualenv, ',
	                        _react2.default.createElement(
	                            'code',
	                            null,
	                            'virtualenv env'
	                        ),
	                        ' and activate it ',
	                        _react2.default.createElement(
	                            'code',
	                            null,
	                            'source env/bin/activate'
	                        ),
	                        '.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Install and run OWTF.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'code',
	                            null,
	                            'cd owtf/; python setup.py develop && python -m owtf'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Open ',
	                        _react2.default.createElement(
	                            'code',
	                            null,
	                            'localhost:8009'
	                        ),
	                        ' for OWTF web interface.'
	                    )
	                )
	            )
	        )
	    );
	};
	exports.default = NewsListing;
	module.exports = exports['default'];

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	    return _react2.default.createElement(
	        'section',
	        { className: 'hero', id: 'features' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'jumbotron' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'Offensive Web Testing Framework'
	                    )
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'OWASP OWTF is a project that aims to make security assessments as efficient as possible by automating the manual, uncreative part of pen testing. It provides out-of-box support for the OWASP Testing Guide, the NIST and the PTES standards.'
	                )
	            )
	        )
	    );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _features = __webpack_require__(131);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _hero = __webpack_require__(134);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_hero2.default, { data: props.data.allDataJson.edges[0].node.hero }),
	    _react2.default.createElement(_features2.default, { data: props.data.allDataJson.edges[0].node.features })
	  );
	}; /* global graphql */
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-63deea3d9410cfcaeef5.js